var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "9f9f0a78383ac5b01ed68940aa77f49365484b52"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-js@venuescanner"] = {
  id: "9f9f0a78383ac5b01ed68940aa77f49365484b52"
};